import { useEffect, useRef, useState } from 'react'
import { Item } from '../item'
import { apiClient } from 'core/http'

import c from './assets/sass/list.module.scss'

export const List = () => {
    const [maxHeight, setMaxHeight] = useState(0)
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)
    const ref = useRef(null)

    const loadFriends = async () => {
        try {
            const res = await apiClient.get('/friends')
            if (res?.data?.success && Array.isArray(res.data.friends)) {
                setItems(
                    res.data.friends.map((f) => ({
                        id: f.id,
                        nickName: f.username || f.firstName || 'User',
                        reward: f.reward || 10,
                        avatarUrl: f.photoUrl || null,
                    }))
                )
            }
        } catch (e) {
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadFriends()

        const interval = setInterval(() => {
            loadFriends()
        }, 5000)

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        const updateHeight = () => {
            if (!ref.current) {
                return
            }

            const offsetTop =
                ref.current.getBoundingClientRect().top + window.scrollY
            const height = window.innerHeight - (offsetTop + 85)
            setMaxHeight(height)
        }

        updateHeight()
        window.addEventListener('resize', updateHeight)
        window.addEventListener('scroll', updateHeight)

        return () => {
            window.removeEventListener('resize', updateHeight)
            window.removeEventListener('scroll', updateHeight)
        }
    }, [])

    return (
        <div
            className={c.component}
            style={{ height: `${maxHeight}px` }}
            ref={ref}
        >
            <div className={c.wrapper}>
                <ul className={c.list}>
                    {!loading &&
                        items.length > 0 &&
                        items.map((i) => (
                            <Item
                                key={i.id}
                                nickName={i.nickName}
                                reward={i.reward}
                                avatarUrl={i.avatarUrl}
                            />
                        ))}
                </ul>
            </div>
        </div>
    )
}
